
<template>
  <section>
    <b-modal width="680px" :active.sync="isModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title">
            ログイン状態リセット
          </p>
        </header>
        <div class="card-content parent-box">
          <div class="box-request">
            <b-field label="Email"
                     message="ご登録されたメールアドレスに、ログイン状態リセットのご案内が送信されます。">
              <b-input type="email" v-model="email" maxlength="254">
              </b-input>
            </b-field>
            <b-field position="is-centered" style="text-align: center !important;">
              <a class="button is-primary is-rounded" @click="sendLoginReset()" style="margin-top: 10px;" :disabled="disabled" v-if="!disabled">送信する</a>
              <a class="button is-primary is-rounded" style="margin-top: 10px;" :disabled="disabled" v-if="disabled">送信する</a>
            </b-field>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>

export default {
  name: 'ModalLoginResetRequest',
  computed: {
    disabled () {
      return this.email === '' || this.email.indexOf('@') <= 0 || this.isSending
    },
  },
  props: {
    isModalLoginReset: {
      type: Boolean,
      default: false,
      required: true
    },
  },
  data () {
    return {
      isModal: false,
      isSending: false,
      email: ''
    }
  },
  watch: {
    isModalLoginReset () {
      this.isModal = this.isModalLoginReset
    },
  },
  methods: {
    sendLoginReset () {
      this.isSending = true
      this.$store.dispatch('auth/loginResetRequest', {'email': this.email})
        .then((result) => {
          if (result.message) {
            this.sendedBar(result.message)
            this.isModal = false
            this.email = ''
          } else {
            this.sentFailBar(result.error)
          }
        })
        .catch(() => {
          this.sentFailBar('エラーが発生しました。')
        })
        .finally(() => {
          this.isSending = false
        })
    },
    sendedBar (message) {
      this.$buefy.snackbar.open({
        message: message,
        type: 'is-success',
        position: 'is-top'
      })
      this.$emit('cancel')
    },
    sentFailBar (message) {
      this.$buefy.snackbar.open({
        message: message,
        type: 'is-warning',
        position: 'is-top'
      })
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 24px;
  font-weight: 700;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.subtitle {
  font-size: 20px;
  font-weight: 700;
}
.parent-box {
  display: flex;
  justify-content: space-around;
  padding: 40px;
}
.box-request {
  width: 100%;
  height: auto;
  padding: 20px;
  font-size: 15px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalLoginResetRequest.vue